<div id="desktop">
  <app-nav-menu></app-nav-menu>
  <main id="main-content">
    <section class="hero" id="top">
      <div class="page-shell hero__banner">
        <img class="hero__banner-image" src="../../../assets/images/main 3.png" alt="Did you use the Flo App between 11/01/2016 and 02/28/2019? Time is running out to file your claim. You could get money from $59.5 Million in settlements.">
        <a class="hero__banner-cta" [routerLink]="['/file-not-noticed']" id="claim" aria-label="File a claim">
          <img src="../../../assets/images/Cta button.png" alt="">
        </a>
      </div>
    </section>

    <section class="steps section">
      <div class="page-shell">
        <h2 class="steps__heading">It’s easy to file a claim<br>in just a few simple steps.</h2>
        <div class="steps__grid">
          <article class="step-card">
            <img src="../../../assets/images/step-1.png" alt="" aria-hidden="true">
            <span class="step-card__number">1</span>
            <p style="font-weight:bold; text-decoration:underline">Enter your information on the Claim Form <a [routerLink]="['/file-not-noticed']" id="claim" style="color: #006cDb">here.</a></p>
            <p>Review the information below to learn more about the lawsuit and who is eligible for a payment.</p>
          </article>
          <article class="step-card">
            <img src="../../../assets/images/step-2.png" alt="" aria-hidden="true">
            <span class="step-card__number">2</span>
            <p style="font-weight:bold; text-decoration:underline">Submit your Claim Form.</p>
            <p>If something changes after you file, you can contact the Settlement Administrator A.B. Data to make updates to your information <a href="mailto:info@PeriodTrackerDataPrivacyLitigation.com" style="color:#006cDb">here.</a></p>
            <!--<p>Remember to select the box if you live in California. This does not affect your claim.</p>-->
          </article>
          <article class="step-card">
            <img src="../../../assets/images/step-3.png" alt="" aria-hidden="true">
            <span class="step-card__number">3</span>
            <p style="font-weight:bold; text-decoration:underline">Choose your payment option.</p>
            <p>After your claim is validated, you will receive an email or text from A.B. Data to choose a digital payment, such as PayPal, Venmo, Apple Pay, Amazon, or direct deposit.  You can also choose to receive your payment by paper check.</p>
            <!--<p>Submit your form and wait for a confirmation email. You can return to check your status.</p>-->
          </article>
          <article class="step-card">
            <img src="../../../assets/images/step-4.png" alt="" aria-hidden="true">
            <span class="step-card__number">4</span>
            <p style="font-weight:bold; text-decoration:underline">You will receive your payment.</p>
            <p>There is nothing more you need to do. Please be patient while your claim is processed.</p>
            <!--<p>That’s it. Now just sit back and wait to get paid.</p>-->
          </article>
        </div>
      </div>
    </section>

    <section class="faq section" id="faq">
      <div class="page-shell faq__grid">
        <div class="faq__intro">
          <h2>FAQs, Questions,<br>and Answers</h2>
          <img src="../../../assets/images/faq-illustration.png" alt="Illustration of legal documents, folders, a scale, and a pen.">
        </div>

        <div class="accordion">
          <article class="accordion__item">
            <h3>
              <button class="accordion__trigger"
                      type="button"
                      [attr.aria-expanded]="openItem() === 1"
                      aria-controls="faq-1"
                      (click)="toggleAccordion(1)">

                <span>What is this lawsuit about?</span>
                <span class="accordion__icon" aria-hidden="true"></span>
              </button>
            </h3>

            @if (openItem() === 1) {
            <div class="accordion__panel" id="faq-1">
              <p>
                Flo Health Inc. (“Flo”) is the maker of an app (the "Flo App") that allows users to track their menstrual cycles, ovulation, pregnancies, and other private health information.
                The lawsuit alleges that between November 1, 2016 and February 28, 2019, Flo incorporated code from Flurry, Inc. (“Flurry”),
                Meta Platforms, Inc. (f/k/a Facebook, Inc.) (“Meta”), and Google, LLC (“Google”) software development kits (“SDKs”) into the Flo App.
                This code allegedly enabled Flurry, Meta, and Google to record users’ confidential, in-app health communications without their consent and
                in violation of the law.<br /><br />


                On July 21, 2025, the case proceeded to trial. Before the Court ruled on these claims, Flo, Flurry, and Google agreed to settle the lawsuit. They deny all of Plaintiffs’
                allegations and assert they did nothing wrong.<br /><br />

                The trial concluded on August 1, 2025, with a landmark jury verdict—finding Meta liable for its role in the unauthorized collection and commercial use of highly personal health
                data entered into the Flo App in violation of the California Invasion of Privacy Act (the “Meta Verdict”). If you are eligible to receive money from Meta Verdict,
                you will be contacted at a later time. Your choices related to this Settlement Fund will not impact your right to receive money from the Meta Verdict.


              </p>
            </div>
            }
          </article>


          <article class="accordion__item">
            <h3>
              <button class="accordion__trigger"
                      type="button"
                      [attr.aria-expanded]="openItem() === 2"
                      aria-controls="faq-2"
                      (click)="toggleAccordion(2)">

                <span>What’s included in the Settlements?</span>
                <span class="accordion__icon" aria-hidden="true"></span>
              </button>
            </h3>

            @if (openItem() === 2) {
            <div class="accordion__panel" id="faq-2">
              <p>
                Google agreed to pay $48,000,000, Flo agreed to pay $8,000,000, and Flurry agreed to pay $3,500,000 to the Class in exchange for releases of all claims in the case and
                related claims.  The combined Settlements of $59,500,000 will be used to compensate eligible Class Members who submit valid and timely Claim Forms, and to pay for
                notice and settlement administration costs, taxes, service awards for representative Plaintiffs, attorneys’ fees, and litigation expenses.

              </p>
            </div>
            }
          </article>



          <article class="accordion__item">
            <h3>
              <button class="accordion__trigger"
                      type="button"
                      [attr.aria-expanded]="openItem() === 3"
                      aria-controls="faq-3"
                      (click)="toggleAccordion(3)">

                <span>Who can receive compensation from the Settlements?</span>
                <span class="accordion__icon" aria-hidden="true"></span>
              </button>
            </h3>

            @if (openItem() === 3) {
            <div class="accordion__panel" id="faq-3">
              <p>
                You can receive compensation from the Settlements if you are a Court-certified nationwide Class Member and/or California Subclass Member, and you are not excluded from the
                Class or California Subclass by definition.
              </p> <br /><br />
              <ul>
                <li>
                  <b>Class Members:</b>  Individuals who used the Flo App in the United States between November 1, 2016 and February 28, 2019, and entered menstruation and/or pregnancy information
                  into the Flo App during that time, unless excluded.
                </li>
                <li>
                  <b>California Subclass Members:</b> Individuals who used the Flo App while living in California between November 1, 2016 and February 28, 2019 and entered menstruation
                  and/or pregnancy information into the Flo App during that time, unless excluded. California Subclass Members are eligible to receive a larger proportional share of
                  the Settlements than Class Members who lived in other states.
                </li>
                <li>
                  <b>Exclusions:</b> (1) any Judge or Magistrate presiding over this action and any member(s) of their families; (2) Defendants, Defendants’ subsidiaries, parents, successors,
                  predecessors, and any entity in which Defendants or their parents have a controlling interest and their current or former employees, officers, and directors;
                  (3) individuals who properly executed and filed a request for exclusion from the Class by July 20, 2025; (4) individuals whose claims in this matter have been finally
                  adjudicated on the merits or otherwise released; (5) Plaintiffs’ counsel and Defendants’ counsel; and (6) the legal representatives, successors, and assigns of any
                  excluded persons.
                </li>
              </ul>






            </div>
            }
          </article>

        </div>
      </div>
    </section>

    <section class="rights section" id="rights">
      <div class="page-shell">
        <div class="rights__heading-row">
          <h2>Your Legal Rights and Options<br>in these Settlements</h2>
          <img src="assets/images/legal-illustration.png" alt="Illustration of a judge's gavel, settlement folder, and legal document.">
        </div>

        <div class="rights-table" role="table" aria-label="Legal rights and options">
          <div class="rights-row" role="row">
            <div class="rights-row__label" role="rowheader"><p style="font-size:1.2em">Do Nothing</p></div>
            <div class="rights-row__description" role="cell"><p style="font-size:1.2em">If you do nothing, you will <strong>receive no payment from the Settlements.</strong></p></div>
          </div>

          <div class="rights-row" role="row">
            <div class="rights-row__label" role="rowheader"><a [routerLink]="['/file-not-noticed']" class="rights-row__label" role="rowheader" style="font-size:1.2em">Submit a Claim Form</a></div>
            <div class="rights-row__description" role="cell">
              <p style="font-size:1.2em">
                To receive your share of the Settlements, complete and submit a timely and valid Claim Form: (1) electronically by <strong>
                  no later than 11:59 p.m. Pacific Time on
                  October 15, 2026,
                </strong> or (2) by mail  postmarked <strong>no later than October 15, 2026.</strong>
              </p>
            </div>
          </div>

          


          <div class="rights-row" role="row">
            <div class="rights-row__label" role="rowheader"><p style="font-size:1.2em">Object</p></div>
            <div class="rights-row__description" role="cell"><p style="font-size:1.2em">If you wish to object to the Settlements, you must file a written objection with the Court <strong>no later than October 8, 2026.</strong> You must be a Class Member or California Subclass Member to object.</p></div>
          </div>
          <div class="rights-row" role="row">
            <div class="rights-row__label" role="rowheader"><p style="font-size:1.2em">Go to the Final Approval Hearing</p></div>
            <div class="rights-row__description" role="cell">
              <p style="font-size:1.2em">
                As part of your written objection, you may ask the Court for permission to speak about the Settlements at the Final Approval Hearing,
                which you must file with the Court <strong>no later than October 8, 2026.</strong> The Final Approval Hearing is scheduled for <strong>October 29, 2026 at 11:00 a.m. Pacific Time.</strong>
              </p>
            </div>
          </div>
          <div class="rights-row" role="row">
            <div class="rights-row__label" role="rowheader"><p style="font-size:1.2em">Appear Through an Attorney</p></div>
            <div class="rights-row__description" role="cell"><p style="font-size:1.2em">Your attorney may attend the Final Approval Hearing on your behalf at your own expense.</p></div>
          </div>
          <div class="rights-row" role="row">
            <div class="rights-row__label" role="rowheader"><p style="font-size:1.2em">Opt Out</p></div>
            <div class="rights-row__description" role="cell"><p style="font-size:1.2em">You are no longer able to “opt out” or exclude yourself from the Class. The deadline to exclude yourself from the Class was July 20, 2025 and has passed.</p></div>
          </div>
        </div>
      </div>
    </section>
  </main>
</div>













